import { render } from "./ImplantsAdditionalProcedure.vue?vue&type=template&id=bb65ac02"
import script from "./ImplantsAdditionalProcedure.vue?vue&type=script&lang=js"
export * from "./ImplantsAdditionalProcedure.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__